import React from 'react';
import '../css/styles.css'
import FormsPortal from './formsportal/FormsPortal'

function Home() {
  return (
    <div>
    <FormsPortal/>
    </div>
  );
}

export default Home;